import { useRouter } from 'next/router';

import Avatar from '~components/Avatar';
import User from '~components/Icon/User';
import useMyInfoQuery from '~hooks/query/user/useMyInfoQuery';
import useMoveOneIdPage from '~hooks/useMoveOneIdPage';

import * as S from './style';

interface Props {
  isNew?: boolean;
  onClick?: () => void;
}

export default function ButtonLogin({ isNew, onClick }: Props) {
  const router = useRouter();
  const { data: myInfoData, status, isActiveUser } = useMyInfoQuery();
  const moveOneIdPage = useMoveOneIdPage();

  const handleClick = () => {
    router.push('/mypage/career');

    if (onClick) {
      onClick();
    }
  };

  return (
    <S.ButtonLogin
      data-attribute-id='gnb'
      data-gnb-kind={isActiveUser ? 'profileMypage' : 'signupLogin'}>
      {isActiveUser ? (
        <Avatar size={32} thumbnail={myInfoData?.profileUrl} isNew={isNew} onClick={handleClick} />
      ) : (
        <User onClick={() => moveOneIdPage()} />
      )}
    </S.ButtonLogin>
  );
}
